"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchPageDictionary = void 0;
exports.searchPageDictionary = {
    applyBtnLabel: 'Filter - Apply',
    cancelBtnLabel: 'Filter - Cancel',
    closeBtnLabel: 'Filter - Close',
    communicationErrorMessage: 'Communication Error Message',
    doneBtnLabel: 'Filter - Done',
    filterBtnLabel: 'Filter - Filter',
    filterHeaderDefaultLabel: 'Filter - Filter by',
    resetBtnLabel: 'Filter - Clear Filters',
    showLessBtnLabel: 'Show less',
    showMoreBtnLabel: 'Show more',
    archived: 'Search Results - Archived',
    didYouMeanMessage: 'Search Results - Did You Mean Message',
    lastModifiedDate: 'Search Results - Last modified date',
    updated: 'Tab Table - Updated',
    releaseDate: 'Search Results - Release date',
    softwareReleaseDate: 'Search Results - Software release date',
    multilanguage: 'Search Results - Multilanguage',
    numberOfItems: 'Search Results - Results',
    searchResultsFor: 'Search Results - Search Results For',
    search: 'Accessibility label - Search',
    searchButton: 'Search',
    selectSegmentInfoMessage: 'Search Results - Select Segment Info Message',
    zeroResultMessage: 'Search Results - Zero Result Message',
    authority: 'Search Results - Authority',
    authorityLabel: 'Search Results - Authority - Label',
    productFamily: 'Search Results - Product Family',
    productGroup: 'Search Results - Product Group',
    productSeries: 'Search Results - Product Series',
    productType: 'Search Results - Product Type',
    productHierarcyLabel: 'Search Results - Product hierarchy - Label',
    byCategory: 'Search Results - By Category',
    level: 'Search Results - Level',
    dhsProductHierarchyLevel1Label: 'Product hierarchy label - DHS Level1',
    dhsProductHierarchyLevel2Label: 'Product hierarchy label - DHS Level2',
    dhsProductHierarchyLevel3Label: 'Product hierarchy label - DHS Level3',
    archivedFilter: 'Search Group Filters - Archived',
    archivedGroup: 'Search Group Filters - Archived Group',
    documentTypes: 'Search Group Filters - Document Types',
    downloadSoftwareType: 'Search Group Filters - Software Types',
    downloadSoftwareCharacteristic: 'Search Group Filters - Software Characteristic',
    drawingType: 'Search Group Filters - Drawing Types',
    hierarchy: 'Search Group Filters - Hierarchy',
    languages: 'Search Group Filters - Languages',
    publishedFilter: 'Search Group Filters - Published',
    type: 'Search Group Filters - Type',
    courseCategory: 'Search Group Filters - Course category',
    approvalType: 'Search Group Filters - Approval Type',
    offeredAs: 'Search Group Filters - Offered as',
    learningEventType: 'Search Group Filters - Learning event type',
    course: 'Search Group Filters - Course',
    curriculum: 'Search Group Filters - Curriculum',
    version: 'Tab Table - Version',
    country: 'Search Results - Country',
    jobArea: 'Search Results - Job Area',
    language: 'Search Results - Language',
    location: 'Search Results - Location',
    experienceLevel: 'Search Results - Experience Level',
    expireDate: 'Search Results - Expire date',
    searchInResultsPlaceholder: 'Search Results - Search in results',
    productionSite: 'Search Results - Production site',
    documentsLinkTitle: 'Information Object - Documents Link Title',
    learnMore: 'Information Object - Learn More',
    storeLinkTitle: 'Information Object - Store Link Title',
    validForLabel: 'Valid for - Label',
    validForAllCountries: 'Valid for - All countries/cities',
    multipleLabel: 'Valid for - Multiple label',
    multipleTooltipMessage: 'Valid for - Multiple tooltip message',
    globalTooltipMessage: 'Valid for - Global tooltip message',
    sortBtnLabel: 'Sort - Sort by',
    sortRelevanceLabel: 'Sort - Relevance',
    sortNewestToOldestLabel: 'Sort - Newest to oldest',
    sortOldestToNewestLabel: 'Sort - Oldest to newest',
    sortMenuOpenLabel: 'Sort - Open sort menu',
    sortMenuCloseLabel: 'Sort - Close sort menu',
};
